import { useMutation, useQueryClient } from 'react-query'
import { generateImages } from '../services/api'

export function useGenerateImage() {
  const queryClient = useQueryClient()

  return useMutation((formData) => generateImages(formData), {
    onSuccess: (data) => {
      // Invalidar queries relacionadas quando novas imagens são geradas
      queryClient.invalidateQueries('generatedArts')

      // Processar a resposta conforme necessário
      return data
    },
  })
}
